/*
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2020-06-04 15:46:42
 * @LastEditors: Jianyong Wang
 * @LastEditTime: 2021-09-29 14:21:06
 */
import { IStore } from './types.d'

const getters = {
  token: (state: IStore) => state.user.token,
  user: (state: IStore) => state.user.userInfo,
  theme: (state: IStore) => state.app.theme
}
export default getters
